/* eslint-disable node/prefer-global/process */
import { useAutobidAuth } from '@autobid//nuxt-auth/src/composables/useAutobidAuth'
import { useAuctionId } from '@autobid/ui/composables/useAuctionId'

export function useCountAuctionVisit() {
  const auctionId = useAuctionId()
  const { $trpc } = useNuxtApp()
  const { isAuthed } = useAutobidAuth()

  const countVisit = async () => {
    if (!auctionId.value) {
      return
    }

    try {
      await $trpc.webapi.countAuctionVisit.mutate({ auctionId: auctionId.value })
    }
    catch {
      // do nothing
    }
  }

  const handleCountVisitation = () => {
    if (!isAuthed.value || !process.client)
      return
    const LAST_AUCTION_ID_KEY = 'lastAuctionId'
    const lastAuctionId = sessionStorage.getItem(LAST_AUCTION_ID_KEY)
    if (Number(lastAuctionId) !== auctionId.value) {
      countVisit()
      sessionStorage.setItem(LAST_AUCTION_ID_KEY, `${auctionId.value}`)
    }
  }

  return {
    handleCountVisitation,
  }
}
